import ForgotPassword from "../authentication/forgot-password/forgotPassword";
import Logout from "../authentication/logout/logout";
import Signin from "../authentication/signin/signin";
import Signup from "../authentication/signup/signup";

import AnalyticsDashboard from "../components/analysis/analytics-dashboard/analytics-dashboard";
import Reports from "../components/analysis/reports/reports";
import BenefitDetails from "../components/benefits/benefit-details/benefit-details";
import BenefitRequests from "../components/benefits/benefit-requests/benefit-requests";
import MyBenefits from "../components/benefits/my-benefits/my-benefits";
import CompanyFiles from "../components/files/company-files/company-files";
import ConfidentialFiles from "../components/files/confidential-files/confidential-files";
import ESignFiles from "../components/files/e-sign-files/e-sign-files";
import EmployeeFiles from "../components/files/employee-files/employee-files";
import MyFiles from "../components/files/my-files/my-files";
import EmployeeEvaluation from "../components/growth/employee-evaluation/employee-evaluation";
import EmployeeGoals from "../components/growth/employee-goals/employee-goals";
import MyEvaluation from "../components/growth/my-evaluation/my-evaluation";
import MyGoals from "../components/growth/my-goals/my-goals";
import OneOnOne from "../components/growth/one-on-one/one-on-one";
import Survey from "../components/growth/survey/survey";
import TeamEvaluation from "../components/growth/team-evaluation/team-evaluation";
import TeamGoals from "../components/growth/team-goals/team-goals";
import Dashboard from "../components/home/home";
import CompanyPayroll from "../components/payroll/company-payroll/company-payroll";
import EmployeePayroll from "../components/payroll/employee-payroll/employee-payroll";
import PayrollAnalytics from "../components/payroll/payroll-analytics/payroll-analytics";
import Profile from "../components/profile/profile";
import Attendance from "../components/settings/attendance/attendance";
import Benefits from "../components/settings/benefits/benefits";
import CalendarComp from "../components/settings/calender/calender";
import Departments from "../components/settings/departments/departments";
import Files from "../components/settings/files/files";
import Flows from "../components/settings/flows/flows";
import Integration from "../components/settings/integration/integration";
import Location from "../components/settings/location/location";
import MyCompany from "../components/settings/myCompany/myCompany";
import OneOnOnes from "../components/settings/one_on_ones/one-on-ones";
import One_on_ones from "../components/settings/one_on_ones/one-on-ones";
import PayRoll from "../components/settings/payRoll/payRoll";
import Performance from "../components/settings/performance/performance";
import Personalization from "../components/settings/personalization/personalization";
import RolesAndPermission from "../components/settings/rolesAndpermission/RolesAndPermission";
import Surveys from "../components/settings/surveys/surveys";
import Tasks from "../components/settings/tasks/tasks";
import TimeOff from "../components/settings/timeOff/timeOff";
import EmployeeTasks from "../components/tasks/employee-tasks/employee-tasks";
import ManageTasks from "../components/tasks/manage-tasks/manage-tasks";
import MyTasks from "../components/tasks/my-tasks/my-tasks";
import CompanyStructure from "../components/team/company-structure/company-structure";
import AddNewEmployee from "../components/team/employe-diractory/add-employee/add-new-employee/addNewEmployee";
import EmployeDiractory from "../components/team/employe-diractory/EmployeDiractory";
import EmployeeClub from "../components/team/employee-club/employee-club";
import ImportPeople from "../components/team/import-people/import-people";
import Recruitment from "../components/team/recruitment/recruitment";
import EmployeeAttendance from "../components/time/employee-attendance/employee-attendance";
import EmployeeTimeOff from "../components/time/employee-time-off/employee-time-off";
import ImportTimeOff from "../components/time/import-time-off/import-time-off";
import MyAttendance from "../components/time/my-attendance/my-attendance";
import MyTimeOff from "../components/time/my-time-off/my-time-off";
import PolicyBalance from "../components/time/policy-balance/policy-balance";
import TimeOffCalender from "../components/time/time-off-calender/time-off-calender";
import TimeOffRequest from "../components/time/time-off-request/time-off-request";
import {
  ANALYTICS_DASHBOARD_PATH,
  ATTENDANCE_PATH,
  BENEFITS_DETAILS_PATH,
  BENEFITS_PATH,
  BENEFITS_REQUESTS_PATH,
  CALENDAR_PATH,
  COMPANY_FILES_PATH,
  COMPANY_PAYROLL_PATH,
  COMPANY_STRUCTURE_PATH,
  CONFIDENTIAL_FILES_PATH,
  DEPARTMENTS_PATH,
  EMPLOYEE_ATTENDANCE_PATH,
  EMPLOYEE_CLUB_PATH,
  EMPLOYEE_DIRECTORY_PATH,
  EMPLOYEE_EVALUATION_PATH,
  EMPLOYEE_FILES_PATH,
  EMPLOYEE_GOALS_PATH,
  EMPLOYEE_PAYROLL_PATH,
  EMPLOYEE_TASKS_PATH,
  EMPLOYEE_TIME_OFF_PATH,
  E_SIGN_PATH,
  FILES_PATH,
  FLOWS_PATH,
  IMPORT_PEOPLE_PATH,
  IMPORT_TIME_OFF_PATH,
  INTEGRATION_PATH,
  LOCATIONS_PATH,
  LOGOUT_PATH,
  MANAGE_TASKS_PATH,
  MY_ATTENDANCE_PATH,
  MY_BENEFITS_PATH,
  MY_COMPANY_PATH,
  MY_EVALUATION_PATH,
  MY_FILES_PATH,
  MY_GOALS_PATH,
  MY_TASKS_PATH,
  MY_TIME_PATH,
  ONE_ON_ONE_PATH,
  PAYROLL_ANALYTICS_PATH,
  PAYROLL_PATH,
  PERFORMANCE_PATH,
  PERSONALISATION_PATH,
  POLICY_BALANCE_PATH,
  PROFILE_PATH,
  RECRUITMENT_PATH,
  REPORTS_PATH,
  ROLES_AND_PERMISSIONS_PATH,
  SLASH_PATH,
  SURVAY_PATH,
  TASKS_PATH,
  TEAM_EVALUATION_PATH,
  TEAM_GOALS_PATH,
  TIME_OFF_CALENDAR_PATH,
  TIME_OFF_PATH,
  TIME_OFF_REQUEST_PATH,
} from "./routes-constant";

export const routes = [
    { id: 16, path: "/growth/my-evaluation", component: <MyEvaluation /> },
  { id: 1, path: SLASH_PATH, component: <Dashboard /> },
  // teams
  { id: 2, path: EMPLOYEE_DIRECTORY_PATH, component: <EmployeDiractory /> },
  { id: 3, path: COMPANY_STRUCTURE_PATH, component: <CompanyStructure /> },
  { id: 4, path: EMPLOYEE_CLUB_PATH, component: <EmployeeClub /> },
  { id: 5, path: IMPORT_PEOPLE_PATH, component: <ImportPeople /> },
  { id: 6, path: RECRUITMENT_PATH, component: <Recruitment /> },
  // time
  { id: 7, path: MY_TIME_PATH, component: <MyTimeOff /> },
  { id: 8, path: EMPLOYEE_TIME_OFF_PATH, component: <EmployeeTimeOff /> },
  { id: 9, path: TIME_OFF_CALENDAR_PATH, component: <TimeOffCalender /> },
  { id: 10, path: TIME_OFF_REQUEST_PATH, component: <TimeOffRequest /> },
  { id: 11, path: POLICY_BALANCE_PATH, component: <PolicyBalance /> },
  { id: 12, path: IMPORT_TIME_OFF_PATH, component: <ImportTimeOff /> },
  { id: 13, path: MY_ATTENDANCE_PATH, component: <MyAttendance /> },
  {
    id: 14,
    path: EMPLOYEE_ATTENDANCE_PATH,
    component: <EmployeeAttendance />,
  },
  // growth
  { id: 15, path: SURVAY_PATH, component: <Survey /> },
  { id: 16, path: MY_EVALUATION_PATH, component: <MyEvaluation /> },
  { id: 17, path: TEAM_EVALUATION_PATH, component: <TeamEvaluation /> },
  {
    id: 18,
    path: EMPLOYEE_EVALUATION_PATH,
    component: <EmployeeEvaluation />,
  },
  { id: 19, path: MY_GOALS_PATH, component: <MyGoals /> },
  { id: 20, path: TEAM_GOALS_PATH, component: <TeamGoals /> },
  { id: 21, path: EMPLOYEE_GOALS_PATH, component: <EmployeeGoals /> },
  { id: 22, path: ONE_ON_ONE_PATH, component: <OneOnOne /> },
  // files
  { id: 23, path: MY_FILES_PATH, component: <MyFiles /> },
  { id: 24, path: EMPLOYEE_FILES_PATH, component: <EmployeeFiles /> },
  { id: 25, path: COMPANY_FILES_PATH, component: <CompanyFiles /> },
  {
    id: 26,
    path: CONFIDENTIAL_FILES_PATH,
    component: <ConfidentialFiles />,
  },
  { id: 27, path: E_SIGN_PATH, component: <ESignFiles /> },
  // my tasks
  { id: 28, path: MY_TASKS_PATH, component: <MyTasks /> },
  { id: 29, path: EMPLOYEE_TASKS_PATH, component: <EmployeeTasks /> },
  { id: 30, path: MANAGE_TASKS_PATH, component: <ManageTasks /> },
  // my benefits
  { id: 31, path: MY_BENEFITS_PATH, component: <MyBenefits /> },
  { id: 32, path: BENEFITS_DETAILS_PATH, component: <BenefitDetails /> },
  {
    id: 33,
    path: BENEFITS_REQUESTS_PATH,
    component: <BenefitRequests />,
  },
  // analysis
  {
    id: 34,
    path: ANALYTICS_DASHBOARD_PATH,
    component: <AnalyticsDashboard />,
  },
  { id: 35, path: REPORTS_PATH, component: <Reports /> },
  // payroll
  {
    id: 36,
    path: PAYROLL_ANALYTICS_PATH,
    component: <PayrollAnalytics />,
  },
  { id: 37, path: COMPANY_PAYROLL_PATH, component: <CompanyPayroll /> },
  { id: 38, path: EMPLOYEE_PAYROLL_PATH, component: <EmployeePayroll /> },
  // settings
  { id: 39, path: MY_COMPANY_PATH, component: <MyCompany /> },
  { id: 40, path: LOCATIONS_PATH, component: <Location /> },
  { id: 41, path: DEPARTMENTS_PATH, component: <Departments /> },
  { id: 42, path: CALENDAR_PATH, component: <CalendarComp /> },
  { id: 43, path: FLOWS_PATH, component: <Flows /> },
  { id: 44, path: TIME_OFF_PATH, component: <TimeOff /> },
  { id: 45, path: ATTENDANCE_PATH, component: <Attendance /> },
  { id: 46, path: SURVAY_PATH, component: <Surveys /> },
  { id: 47, path: PERFORMANCE_PATH, component: <Performance /> },
  { id: 48, path: ONE_ON_ONE_PATH, component: <OneOnOnes /> },
  { id: 49, path: FILES_PATH, component: <Files /> },
  { id: 50, path: TASKS_PATH, component: <Tasks /> },
  { id: 51, path: BENEFITS_PATH, component: <Benefits /> },
  { id: 52, path: PAYROLL_PATH, component: <PayRoll /> },
  {
    id: 53,
    path: ROLES_AND_PERMISSIONS_PATH,
    component: <RolesAndPermission />,
  },
  { id: 54, path: INTEGRATION_PATH, component: <Integration /> },
  { id: 55, path: PERSONALISATION_PATH, component: <Personalization /> },
  { id: 56, path: PROFILE_PATH, component: <Profile /> },
  { id: 57, path: LOGOUT_PATH, component: <Logout /> },
  {id:57, path: "/signin", component: <Signin/>},
  {id:57, path: "/forgot-password", component: <ForgotPassword/>},
];
